import React from 'react';
import Icon from '../../../components/AppIcon';

const MembershipPlansPanel = () => {
  const plans = [
    {
      name: 'Basic',
      price: 29,
      features: [
        'Access to gym equipment',
        'Locker room access',
        'Basic workout tracking',
        'Mobile app access'
      ],
      icon: 'Dumbbell',
      color: 'text-muted-foreground'
    },
    {
      name: 'Premium',
      price: 59,
      features: [
        'All Basic features',
        'Group fitness classes',
        'Personal training (2x/month)',
        'Nutrition consultation',
        'Priority booking'
      ],
      icon: 'Star',
      color: 'text-primary',
      popular: true
    },
    {
      name: 'Elite',
      price: 99,
      features: [
        'All Premium features',
        'Unlimited personal training',
        'Custom meal plans',
        'Recovery zone access',
        'Guest passes (4x/month)',
        '24/7 facility access'
      ],
      icon: 'Crown',
      color: 'text-accent'
    }
  ];

  return (
    <div className="bg-card rounded-xl shadow-md border border-border">
      <div className="p-6 border-b border-border">
        <h2 className="text-xl font-heading font-bold text-foreground flex items-center gap-2">
          <Icon name="CreditCard" size={24} color="var(--color-primary)" />
          Membership Plans
        </h2>
      </div>

      <div className="p-6 space-y-4">
        {plans?.map((plan) => (
          <div
            key={plan?.name}
            className={`p-4 rounded-lg border-2 ${
              plan?.popular
                ? 'border-primary bg-primary/5' :'border-border bg-background'
            }`}
          >
            <div className="flex items-center justify-between mb-3">
              <div className="flex items-center gap-2">
                <Icon name={plan?.icon} size={20} className={plan?.color} />
                <h3 className="font-semibold text-foreground">{plan?.name}</h3>
              </div>
              <div className="text-right">
                <p className="text-2xl font-bold text-foreground">${plan?.price}</p>
                <p className="text-xs text-muted-foreground">per month</p>
              </div>
            </div>
            {plan?.popular && (
              <div className="mb-3">
                <span className="inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium bg-primary text-white">
                  <Icon name="TrendingUp" size={12} />
                  Most Popular
                </span>
              </div>
            )}
            <ul className="space-y-2">
              {plan?.features?.map((feature, index) => (
                <li key={index} className="flex items-start gap-2 text-sm">
                  <Icon name="Check" size={16} className="text-success flex-shrink-0 mt-0.5" />
                  <span className="text-muted-foreground">{feature}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MembershipPlansPanel;